module.exports = __webpack_public_path__ + "img/sii-icon-active.edfc541f.svg";